import { ArrowForwardIos } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { useAppNavigate } from "Infrastructure/Routing/useAppNavigate";

interface DetailActionCellProps {
  path: string;
}

export const DetailActionCell = ({
  path,
}: DetailActionCellProps): React.ReactNode => {
  const navigate = useAppNavigate();

  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        navigate(path);
      }}
      sx={{
        padding: 0.5,
        backgroundColor: "transparent",
        fontSize: 14,
        "&:hover": { backgroundColor: "transparent" },
      }}
    >
      <ArrowForwardIos fontSize="inherit" />
    </IconButton>
  );
};
